module.exports = __webpack_public_path__ + "img/jaye-kang-xuanwu.6cd67c8.jpg";